import type { Locale } from 'date-fns'
import {
  enUS as en,
  es,
  fr,
  ko,
  pl,
  ptBR as pt,
  ru,
  zhCN as zh,
} from 'date-fns/locale'
import type { SupportedLocales } from '../hooks/useDateFormatters'

const locales = {
  en,
  es,
  fr,
  ko,
  pl,
  pt,
  ru,
  zh,
}

function getCurrentLocale(locale: string): Locale {
  return locales[locale as SupportedLocales] || locales.en
}

export default getCurrentLocale
